
import Qrcode from 'vux/src/components/qrcode/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import { LANG } from '@/constants/lang'

export default{
data () {
return {
amount: 0,
address: '',
scripts: '00000000',
totalTime: 90,
content: '90',
languages: [
{
key: 'cn',
value: 'zh_CN'
}, {
key: 'tw',
value: 'zh_TW'
}, {
key: 'en',
value: 'EN'
}, {
key: 'vn',
value: 'VN'
}
],
selectoption: ''
}
},
mounted () {
this.qrcode = this.$router.currentRoute.query.qrcode
this.$models.Deposit.qrcode({ order_no: this.qrcode })
.then(response => {
if (response.data.success) {
response = response.data.data
this.address = response.address
this.scripts = response.scripts
this.amount = `${response.symbol} ${response.amount}`
} else {
this.$router.replace({
path: '/error',
query: {
title: `${this.$t('channelUnavailable')}`,
description1: `${response.data.message}`
}
})
}
})
this.setLocale()
this.countDown()
},
components: {
Qrcode,
XHeader,
Box,
XButton,
ViewBox,
Grid,
GridItem,
GroupTitle,
Divider,
XInput,
Popup,
PopupRadio
},
methods: {
countDown () {
let clock = window.setInterval(() => {
this.totalTime--
this.content = this.totalTime
if (this.totalTime < 1) {     // 当倒计时小于0时清除定时器
window.clearInterval(clock)
}
}, 1000)
},
copy () {
navigator.clipboard.writeText(this.qrcode || '')
},
setLocale () {
this.$models.Deposit.ip().then(({ data }) => {
const lang = LANG[data.data.locale_id]
this.selectoption = lang

if (!localStorage.getItem('lang')) {
localStorage.setItem('lang', lang)
this.$i18n.locale = lang
}

this.resetLangList()
})
},
switchLang () {
const lang = this.selectoption

this.$i18n.locale = lang
localStorage.setItem('lang', lang)
this.resetLangList()
},
resetLangList () {
this.languages = [
{ key: 'cn', value: this.$t('cn') },
{ key: 'tw', value: this.$t('tw') },
{ key: 'en', value: this.$t('en') },
{ key: 'vn', value: this.$t('vn') }
]
}
}
}



// WEBPACK FOOTER //
// ./src/components/Qrcode.vue